import React, { useState } from "react";
import ReactTooltip from "react-tooltip";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import Barcode from "react-barcode";
import Currency from "react-currency-formatter";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";

import {
  Container,
  Header,
  Left,
  Title,
  CloseIcon,
  Icon,
  Content,
  CardTitle,
  Info,
  InfoTitle,
  InfoText,
  Hr,
  DetailsContainer,
  DetailsContent,
  SectionTitle,
  DownloadAreaContainer,
  DownloadButton,
  DownloadIcon,
  DownloadLoading,
  Accesskey,
  AccessKeyContent,
  AccesskeyTextContainer,
  DownloadContainer,
} from "./styles";
import { Creators as InvoiceActions } from "~/store/ducks/invoice";
import api from "~/services/api";

function Modal({ close, modalInformation, access_token, login_email }) {
  const invoice = modalInformation;
  const installment = invoice.installments;
  const customer = invoice.customer;

  function requestDownloadNota() {
    const header = {
      "Content-Type": "application/json",
      access_token: localStorage.getItem("access_token")
    };
    const parameters = {
      method: "POST",
      responseType: "blob",
      headers: header,
    };
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      documentType: "XML",
      deliveryMethod: "DOWNLOAD",
      contactIdSf: localStorage.getItem("contactIdSf"),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}`,
        body,
        parameters
      )
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${invoice.invoiceId}.xml`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((err) => {
        const erro = err.response.data;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          } else {
            localStorage.clear();
            window.location.href = "/acessar?error";
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      });
  }

  function requestDownloadNotaPdf() {
    const header = {
      "Content-Type": "application/json",
      access_token: localStorage.getItem("access_token")
    };
    const parameters = {
      method: "POST",
      responseType: "blob",
      headers: header,
    };
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      documentType: "DANFE",
      deliveryMethod: "DOWNLOAD",
      contactIdSf: localStorage.getItem("contactIdSf"),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}`,
        body,
        parameters
      )
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${invoice.invoiceId}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((err) => {
        if (err.response.status === 404) {
          toast.error("Apenas formato XML é disponível para esta nota.");
        }
        const erro = err.response.data;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          } else {
            localStorage.clear();
            window.location.href = "/acessar?error";
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      });
  }

  function requestEmailNota() {
    const header = {
      "Content-Type": "application/json",
      access_token: localStorage.getItem("access_token")
    };
    const parameters = {
      method: "POST",
      headers: header,
    };
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      documentType: "XML",
      deliveryMethod: "EMAIL",
      email: login_email,
      contactIdSf: localStorage.getItem("contactIdSf"),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}`,
        body,
        parameters
      )
      .then((res) => {
        if (res.status) {
          if (res.status === 204) {
            toast.success(`Nota enviada para o e-mail ${login_email}`);
          }
        }
      })
      .catch((err) => {
        const erro = err.response;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          } else {
            localStorage.clear();
            window.location.href = "/acessar?error";
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      });
  }

  function requestEmailNotaPdf() {
    const header = {
      "Content-Type": "application/json",
      access_token: localStorage.getItem("access_token")
    };
    const parameters = {
      method: "POST",
      headers: header,
    };
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      documentType: "DANFE",
      deliveryMethod: "EMAIL",
      email: login_email,
      contactIdSf: localStorage.getItem("contactIdSf"),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}`,
        body,
        parameters
      )
      .then((res) => {
        if (res.status) {
          if (res.status === 204) {
            toast.success(`Nota enviada para o e-mail ${login_email}`);
          }
        }
      })
      .catch((err) => {
        if (err.response.status === 404) {
          toast.error("Não foi possível encontrar essa nota em nosso sistema!");
        }
        const erro = err.response;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          } else {
            localStorage.clear();
            window.location.href = "/acessar?error";
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      });
  }

  return (
    <Container className="background">
      <Header>
        <Left>
          <Icon className="mdi mdi-receipt mr-2" />
          <Title>Notas</Title>
        </Left>
        <CloseIcon
          title="Fechar"
          className="mdi mdi-close"
          onClick={() => (window.location.href = "/notas")}
        />
      </Header>
      <Content>
        <CardTitle>Detalhes da Cobrança</CardTitle>
        <Info className="mt-3">
          <InfoTitle>Cliente:</InfoTitle>
          <InfoText>{customer.name}</InfoText>
        </Info>
        <Info className="mt-2">
          <InfoTitle>Endereço:</InfoTitle>
          <InfoText>
            {customer.address}, {customer.addressNumber} - {customer.county},{" "}
            {customer.city} - {customer.stateCode}
          </InfoText>
        </Info>
        <Hr />
        <DetailsContainer>
          <SectionTitle>Detalhes</SectionTitle>
          <DetailsContent>
            <Info>
              <InfoTitle>Número da Nota:</InfoTitle>
              <InfoText>{invoice.invoiceNumber}</InfoText>
            </Info>
            <Info>
              <InfoTitle>Emissão:</InfoTitle>
              <InfoText>
                {moment(invoice.emissionDate).add(1, "d").format("DD/MM/YYYY")}
              </InfoText>
            </Info>
            <Info>
              <InfoTitle>Valor:</InfoTitle>
              <InfoText>
                <Currency
                  quantity={invoice.totalAmount}
                  currency="BRL"
                  locale="pt"
                />
              </InfoText>
            </Info>
          </DetailsContent>
          {invoice.existsGeneratedInvoice ? (
            <>
              <AccessKeyContent>
                <AccesskeyTextContainer>
                  <InfoTitle>Chave de acesso:</InfoTitle>
                  <Accesskey title={invoice.accessKey}>
                    {invoice.accessKey}
                  </Accesskey>
                </AccesskeyTextContainer>
              </AccessKeyContent>
              <DownloadAreaContainer className="mt-2">
                <InfoTitle>2ª via da Nota:</InfoTitle>
                <DownloadContainer>
                  <InfoTitle className="mr-1">PDF:</InfoTitle>
                  <DownloadButton
                    className="mr-2"
                    onClick={() => requestDownloadNotaPdf()}
                  >
                    <DownloadIcon className="mdi mdi-download" />
                  </DownloadButton>
                  <DownloadButton onClick={() => requestEmailNotaPdf()}>
                    <DownloadIcon className="mdi mdi-email" />
                  </DownloadButton>
                </DownloadContainer>
                <DownloadContainer>
                  <InfoTitle className="mr-1">XML:</InfoTitle>
                  <DownloadButton
                    className="mr-2"
                    onClick={() => requestDownloadNota()}
                  >
                    <DownloadIcon className="mdi mdi-download" />
                  </DownloadButton>
                  <DownloadButton onClick={() => requestEmailNota()}>
                    <DownloadIcon className="mdi mdi-email" />
                  </DownloadButton>
                </DownloadContainer>
              </DownloadAreaContainer>
            </>
          ) : null}
        </DetailsContainer>
      </Content>
    </Container>
  );
}

const mapStateToProps = (state) => ({
  modalInformation: state.invoiceReducer.modalInformation,
  access_token: state.loginReducer.access_token,
  login_email: state.loginReducer.login_email,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(InvoiceActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
